import { Business } from "@norma-bi/bi-api";

export const AllBusiness: Business = {
  id: "ALL",
  // TODO(yannis): name and display_name will need to be translated when an intl lib is introduced in this project
  name: "ALL BUSINESSES",
  display_name: "ALL BUSINESSES",
  ref: -1,
  venues_count: 0,
  users_count: 0,
  licensing: {
    web_app: {
      licensed: false,
      expires_on: undefined,
    },
    mobile_app: {
      licensed: false,
      expires_on: undefined,
    },
  },
};
export function isAllBusiness(businessId: string): boolean {
  return businessId === AllBusiness.id;
}
